import { render, staticRenderFns } from "./OrderDescription.vue?vue&type=template&id=22df75aa&scoped=true&"
import script from "./OrderDescription.vue?vue&type=script&lang=js&"
export * from "./OrderDescription.vue?vue&type=script&lang=js&"
import style0 from "./OrderDescription.vue?vue&type=style&index=0&id=22df75aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df75aa",
  null
  
)

export default component.exports